import React from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useTranslation } from 'react-i18next';
import Loader from '../../common-components/loader';
import constants from '../../constants';
import { formatAlgos } from '../../utils/formatAlgos';
import { formatPlanets } from '../../utils/formatPlanets';
import TableView from '../tableView';
import { Col } from 'react-bootstrap';

interface Props { loading: boolean }

const ShowAccounts = ({ loading } : Props) => {
  const { t } = useTranslation();

  const columnsAcountsDashboard = [
    { title: t('ACCOUNT'), field: 'name', headerSort: false },
    { title: t('ADDRESS'), field: 'address', headerSort: false, tooltip: true },
    {
      title: t('ALGORANDS'),
      field: 'algorands',
      headerSort: false,
      formatter: formatAlgos
    },
    { title: t('NFT'), field: 'assetsCount', headerSort: false },
    {
      title: t('PLANETS'),
      field: 'planets',
      headerSort: false,
      formatter: formatPlanets
    }
  ];

  return (
    <Col md='5'>
    <div className='card card-dark'>
      <div className='card-header'>{t('PLANETWATCH_ACCOUNTS')}</div>
      <div className='card-body'>
        <TableView
          t={t}
          api={constants.api.getAccountsDashboard}
          apiPagination={false}
          hideSizeSelector={true}
          columns={columnsAcountsDashboard} />
      </div>
      {loading &&
        <div className='overlay'>
          <Loader visible={loading} />
        </div>}
    </div>
  </Col>

  );
};

export default ShowAccounts;